import React from "react";
import "../styles/loading.scss";
const Loading = () => {
  return (
    <div className="notfound ">
      <img src="/assets/img/Logo.png"></img>
    </div>
  );
};
export default Loading;
